// Initial data for first load, matches the API response structure

export default {
  cod: 0,
  clouds: { all: 0 },
  weather: [{ main: '' }]
};
